import {FormControl, ValidatorFn} from '@angular/forms';

export function textControl(validators: ValidatorFn[]): FormControl<string> {
  return new FormControl<string>('', {nonNullable: true, validators});
}
